import Drawer from '@mui/material/Drawer';
import {
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerMainContainer,
  DRAWER_WIDTH
} from '../NRDashboardCharts/NRClickThroughDrawer/NRClickThroughDrawer';
import NRActivityFeedContainer from './NRActivityFeedContainer';

function NRActivityFeed({ openDrawer, handleClose }) {
  return (
    <Drawer
      PaperProps={{ sx: { width: DRAWER_WIDTH } }}
      anchor={'right'}
      open={openDrawer}
      variant={'temporary'}
      onClose={() => handleClose()}
      onKeyDown={event => {
        if (event.key === 'Escape') {
          handleClose();
        }
      }}
    >
      <DrawerMainContainer>
        <DrawerHeader drawerTitle={'Activity Feed'} handleClose={handleClose} />
        <DrawerContent>
          <NRActivityFeedContainer handleClose={handleClose} />
        </DrawerContent>
        <DrawerFooter hasBack={false} handleClose={handleClose} />
      </DrawerMainContainer>
    </Drawer>
  );
}
export default NRActivityFeed;
